import React from 'react';

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {}

export default function LoadingIcon({ className, ...props }: Props) {
  return (
    <div className={`spinner-border text-primary ${className || ''}`} role="status" {...props}>
      <span className="sr-only"></span>
    </div>
  );
}
